

import { t_mode } from "../types/types"
const modal_style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
}

const getModalStyle = ( mode : t_mode) => {
    const top = 30 
    const left = 50 
    return {
      top: `${top}%`,
      left: `${left}%`,
      backgroundColor: mode === 'Dark' ? '#222' : '#fff',
      transform: `translate(-${top}%, -${left}%)`,
    };
}
const getBigModalStyle = ( mode : t_mode) => {
    return {
        backgroundColor: mode === 'Dark' ? '#222' : '#fff',
    };
}

export { modal_style , getModalStyle , getBigModalStyle }